import axios from "axios";

export const baseURL = process.env.REACT_APP_API_SENSEDIA_AUTH || "";

const apiSensedia = axios.create({
    baseURL
});

apiSensedia.interceptors.response.use(
    (response: any) => {
        if (["get", "post"].includes(response.config.method)) {
            //toast.success("OK");
        }
        
        return response;
    },
    (error) => {
        throw error;
    }
);

export default apiSensedia;

